import React, { useMemo } from 'react'
import { SwiperOptions } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'

interface ProductImagesSwiperProps {
  images: {
    src: string
    alt: string
  }[]
}

const ProductImagesSwiper: React.FC<ProductImagesSwiperProps> = ({ images }) => {
  const swiperOptions: SwiperOptions = useMemo(
    () => ({
      spaceBetween: 0,
      slidesPerView: 1,
      lazy: false,
      preloadImages: true,
      pagination: {
        clickable: true,
        el: '#swiper-pagination-quick-view',
      },
      watchSlidesProgress: true,
      loop: true,
      autoHeight: true,
      touchMoveStopPropagation: true,
      preventClicksPropagation: true,
    }),
    []
  )
  return (
    <>
      {!!images.length && (
        <>
          <Swiper {...swiperOptions}>
            {images.map((img, i) => {
              return (
                <SwiperSlide key={i}>
                  <img src={img.src} alt={img.alt} height='auto' className='max-w-full' />
                </SwiperSlide>
              )
            })}
          </Swiper>
          <div
            id='swiper-pagination-quick-view'
            className='swiper-pagination swiper-pagination-clickable swiper-pagination-bullets w-full'
          />
        </>
      )}
    </>
  )
}

export default ProductImagesSwiper
